import $ from 'jquery'

/* @ngInject */
const myNavBar = (

) => {
  return {
    restrict: 'E',
    scope: {
      myMenu: '=',
    },
    template: require('./myNavBar.html'),
    /* @ngInject */
    controller: (
      $scope,
      mainMenu,
      images,
      authService
    ) => {
      $scope.mainMenu = mainMenu
      $scope.images = images
      $scope.user = authService

      let nbMenu = 0
      $scope.mainMenu.forEach(menu => {
        if (menu.display()) {
          nbMenu++
        }
      })

      const col = 12 / nbMenu
      $scope.col = 's' + col

      $('.button-collapse').sideNav()
    },
    link: {
      pre: (scope, element, attrs) => {  },
      post: (scope, element, attrs, ctrl) => { },
    },
  }
}
export default myNavBar



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/directives/menus/myNavBar.js